module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAMCAYAAAAH4W+EAAAAAXNSR0IArs4c6QAAAP9JREFUOE+91M0qRVEYBuDnICOZS/mJERnIyEQZuAlX4AoY00mRJClRShkoZeQmlImLMCIkhPyuT2uX5Jit/dUa7Vrvs/e71m4oM3NYwBmGsZNXy7RGGYcxbOEB9xmzjb1WeaUgkTeJVdzhEUMZt/8XpiQk8qawjNtU1RMGsZlQB78xpSGRN40mrvGCAazj8CemDkjkzWARV3hFH9ZwVGHqgkTeKJbwiXb0YgXH8TAgI+jHc6EbFNt+4BKzmMBN+iJd6Ur35NpOAnKK99xfQct3RlQTqLac2Z0x8wG5wHmSdZRU5L2jlljVvGEcuwGpfjJxiOqezhy4Uedh/fclvwCGzy74vREdgwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/arrow.png
// module id = bJ/F
// module chunks = 0